export const messages = {
  en: {
    shopCreateFee: {
      shopList: 'Shop List',
      shopFee: 'Shop Fee',
      paymentHistory: 'Payment History',
      prePayFee: 'Pre Pay Fee',
      billingRules: 'Billing Rules',
      setFee: 'Set Fee',
      ownerShops: 'Owner Shops',
      owner: 'Owner',
      receiptReprint: 'Receipt Reprint',
      batchCreate: 'Batch Create',
      customImport: 'Custom Import',
      shopNumPlaceholder: 'Please enter shop number',
      selectLocationFirst: 'Please select a location first',
      query: 'Query',
      reset: 'Reset',
      loadLocationError: 'Failed to load locations',
      loadShopError: 'Failed to load shops'
    },
    shopCreatePayFee: {
      title: 'Shop Batch Create Fee',
      feeType: 'Fee Type',
      selectFeeType: 'Please select fee type',
      feeItem: 'Fee Item',
      selectFeeItem: 'Please select fee item',
      startTime: 'Start Time',
      selectStartTime: 'Please select start time',
      endTime: 'End Time',
      selectEndTime: 'Please select end time',
      amount: 'Amount',
      inputAmount: 'Please enter amount',
      rateCycle: 'Rate Cycle',
      inputRateCycle: 'Please enter rate cycle',
      rate: 'Rate',
      inputRate: 'Please enter rate',
      rateStartTime: 'Rate Start Time',
      selectRateStartTime: 'Please select rate start time',
      location: 'Location',
      selectLocation: 'Please select location',
      shop: 'Shop',
      selectAll: 'Select All',
      noShop: 'No shop available',
      validateError: 'Please complete the required fields',
      noShopSelected: 'Please select at least one shop'
    },
    simplifyShopFee: {
      selectFeeType: 'Select Fee Type',
      selectFeeItem: 'Select Fee Item',
      selectStatus: 'Select Status',
      valid: 'Valid',
      feeEnd: 'Fee End',
      batchPayment: 'Batch Payment',
      prePayFee: 'Pre Pay Fee',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      receivableAmount: 'Receivable Amount',
      chargeYearMonth: 'Charge Year-Month',
      receivablePeriod: 'Receivable Period',
      description: 'Description',
      remark: 'Remark',
      status: 'Status',
      operation: 'Operation',
      moreOperations: 'More',
      cancelFee: 'Cancel Fee',
      feeChange: 'Fee Change',
      splitFee: 'Split Fee',
      details: 'Details',
      payment: 'Payment',
      paymentHistory: 'History',
      note1: 'Note: The receivable end time "-" means not yet receivable or fee collection has ended',
      note2: 'Receivable amount -1 generally indicates an error in the fee item formula setting',
      arrearsSubtotal: 'Arrears Subtotal:'
    },
    simplifyShopPrePayFee: {
      addPrePay: 'Add Pre Pay',
      feeName: 'Fee Item',
      payerObjName: 'Payer Object',
      cycles: 'Cycle(Month)',
      receivableReceivedAmount: 'Receivable/Received',
      remainAmount: 'Remain Amount',
      paymentMethod: 'Payment Method',
      prePayPeriod: 'Pre Pay Period',
      status: 'Status',
      createTime: 'Create Time',
      amount: 'Amount',
      amountRequired: 'Amount is required',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark'
    },
    simplifyShopOwner: {
      ownerFace: 'Photo',
      name: 'Name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      idCard: 'ID Card',
      address: 'Address',
      roomCount: 'Room Count',
      memberCount: 'Member Count',
      oweFee: 'Owe Fee',
      actions: 'Actions',
      detail: 'Detail'
    },
    simplifyShopOwnerShops: {
      batchPay: 'Batch Payment',
      shopCode: 'Shop Code',
      location: 'Location',
      area: 'Area',
      validity: 'Validity',
      shopStatus: 'Status',
      shopOweFee: 'Owe Fee',
      actions: 'Actions',
      choose: 'Choose',
      currentShop: 'Current Shop',
      subtotalOweFee: 'Subtotal Owe Fee'
    },
    shopCreateFeeAdd: {
      createFee: 'Create Fee',
      shop: 'Shop',
      feeType: 'Fee Type',
      selectFeeType: 'Please select fee type',
      feeItem: 'Fee Item',
      selectFeeItem: 'Please select fee item',
      billingStartTime: 'Billing Start Time',
      enterBillingStartTime: 'Please select billing start time',
      billingEndTime: 'Billing End Time',
      enterBillingEndTime: 'Please select billing end time',
      feeAmount: 'Fee Amount',
      enterFeeAmount: 'Please enter fee amount',
      feeTypeRequired: 'Fee type is required',
      feeItemRequired: 'Fee item is required',
      billingStartTimeRequired: 'Billing start time is required',
      billingEndTimeRequired: 'Billing end time is required',
      amountRequired: 'Amount is required',
      amountFormatError: 'Please enter a valid amount',
      endTimeAfterStart: 'End time must be after start time',
      createSuccess: 'Fee created successfully',
      createFailed: 'Failed to create fee'
    },
    feeDetailShopFeeRule: {
      createFee: 'Create Fee',
      tempFee: 'Temporary Fee',
      ruleId: 'Rule ID',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Type',
      createTime: 'Create Time',
      validity: 'Validity Period',
      formula: 'Formula',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional Fee',
      status: 'Status',
      valid: 'Valid',
      invalid: 'Invalid',
      billDate: 'Bill Date',
      billCycle: 'Bill Cycle',
      monthly: 'Monthly',
      operation: 'Operation',
      change: 'Edit',
      manualFinish: 'Manual Finish',
      cancel: 'Cancel'
    },
    doImportShopCreateFee: {
      title: 'Import Shop Create Fee',
      template: 'Template',
      downloadTemplate: 'Download Template',
      selectFile: 'Select File',
      clickUpload: 'Click Upload',
      fileTip: 'Only .xls/.xlsx files, max 2MB',
      validate: {
        invalidFileType: 'Invalid file type, only .xls/.xlsx allowed',
        fileTooLarge: 'File too large, max 2MB'
      }
    }
  },
  zh: {
    shopCreateFee: {
      shopList: '商铺列表',
      shopFee: '商铺费用',
      paymentHistory: '缴费历史',
      prePayFee: '预付收款',
      billingRules: '费用规则',
      setFee: '设置费用',
      ownerShops: '业主商铺',
      owner: '业主信息',
      receiptReprint: '补打收据',
      batchCreate: '批量创建',
      customImport: '自定义导入',
      shopNumPlaceholder: '请输入商铺编号',
      selectLocationFirst: '请先选择位置',
      query: '查询',
      reset: '重置',
      loadLocationError: '加载位置失败',
      loadShopError: '加载商铺失败'
    },
    shopCreatePayFee: {
      title: '商铺批量创建费用',
      feeType: '费用类型',
      selectFeeType: '请选择费用类型',
      feeItem: '费用项',
      selectFeeItem: '请选择费用项',
      startTime: '开始时间',
      selectStartTime: '请选择开始时间',
      endTime: '结束时间',
      selectEndTime: '请选择结束时间',
      amount: '金额',
      inputAmount: '请输入金额',
      rateCycle: '计费周期',
      inputRateCycle: '请输入计费周期',
      rate: '费率',
      inputRate: '请输入费率',
      rateStartTime: '费率开始时间',
      selectRateStartTime: '请选择费率开始时间',
      location: '位置',
      selectLocation: '请选择位置',
      shop: '商铺',
      selectAll: '全选',
      noShop: '暂无可选商铺',
      validateError: '请完善必填信息',
      noShopSelected: '请至少选择一个商铺'
    },
    simplifyShopFee: {
      selectFeeType: '选择费用类型',
      selectFeeItem: '选择费用项',
      selectStatus: '选择状态',
      valid: '有效',
      feeEnd: '已终止',
      batchPayment: '批量缴费',
      prePayFee: '预付收款',
      feeItem: '费用项',
      feeFlag: '费用标识',
      feeType: '费用类型',
      receivableAmount: '应收金额',
      chargeYearMonth: '计费年月',
      receivablePeriod: '应收期间',
      description: '描述',
      remark: '备注',
      status: '状态',
      operation: '操作',
      moreOperations: '更多',
      cancelFee: '取消费用',
      feeChange: '费用变更',
      splitFee: '费用拆分',
      details: '详情',
      payment: '缴费',
      paymentHistory: '历史',
      note1: '注意：应收结束时间为"-"表示未开始收取或已停止收费',
      note2: '应收金额为-1一般表示费用项公式设置有误',
      arrearsSubtotal: '欠费小计：'
    },
    simplifyShopPrePayFee: {
      addPrePay: '添加预付',
      feeName: '费用项',
      payerObjName: '缴费对象',
      cycles: '周期(月)',
      receivableReceivedAmount: '应收/实收',
      remainAmount: '剩余金额',
      paymentMethod: '支付方式',
      prePayPeriod: '预付期间',
      status: '状态',
      createTime: '创建时间',
      amount: '金额',
      amountRequired: '金额不能为空',
      remark: '备注',
      remarkPlaceholder: '请输入备注'
    },
    simplifyShopOwner: {
      ownerFace: '照片',
      name: '姓名',
      gender: '性别',
      male: '男',
      female: '女',
      idCard: '身份证号',
      address: '地址',
      roomCount: '房屋数',
      memberCount: '成员数',
      oweFee: '欠费',
      actions: '操作',
      detail: '详情'
    },
    simplifyShopOwnerShops: {
      batchPay: '批量缴费',
      shopCode: '商铺编号',
      location: '位置',
      area: '面积',
      validity: '有效期',
      shopStatus: '状态',
      shopOweFee: '欠费',
      actions: '操作',
      choose: '选择',
      currentShop: '当前商铺',
      subtotalOweFee: '欠费合计'
    },
    shopCreateFeeAdd: {
      createFee: '创建费用',
      shop: '商铺',
      feeType: '费用类型',
      selectFeeType: '请选择费用类型',
      feeItem: '费用项',
      selectFeeItem: '请选择费用项',
      billingStartTime: '计费开始时间',
      enterBillingStartTime: '请选择计费开始时间',
      billingEndTime: '计费结束时间',
      enterBillingEndTime: '请选择计费结束时间',
      feeAmount: '费用金额',
      enterFeeAmount: '请输入费用金额',
      feeTypeRequired: '费用类型不能为空',
      feeItemRequired: '费用项不能为空',
      billingStartTimeRequired: '计费开始时间不能为空',
      billingEndTimeRequired: '计费结束时间不能为空',
      amountRequired: '金额不能为空',
      amountFormatError: '请输入有效的金额',
      endTimeAfterStart: '结束时间必须晚于开始时间',
      createSuccess: '费用创建成功',
      createFailed: '创建费用失败'
    },
    feeDetailShopFeeRule: {
      createFee: '创建费用',
      tempFee: '临时费用',
      ruleId: '规则ID',
      feeItem: '费用项',
      feeFlag: '费用类型',
      createTime: '创建时间',
      validity: '有效期',
      formula: '公式',
      unitPrice: '单价',
      additionalFee: '附加费',
      status: '状态',
      valid: '有效',
      invalid: '无效',
      billDate: '账单日',
      billCycle: '账单周期',
      monthly: '按月',
      operation: '操作',
      change: '编辑',
      manualFinish: '手动终止',
      cancel: '取消'
    },
    doImportShopCreateFee: {
      title: '导入商铺创建费用',
      template: '模版',
      downloadTemplate: '下载模版',
      selectFile: '选择文件',
      clickUpload: '点击上传',
      fileTip: '只能上传xls/xlsx文件，且不超过2MB',
      validate: {
        invalidFileType: '文件格式不正确，仅支持xls/xlsx',
        fileTooLarge: '文件大小不能超过2MB'
      }
    }
  },
  'zh-TW': {
    shopCreateFee: {
      shopList: '商鋪列表',
      shopFee: '商鋪費用',
      paymentHistory: '繳費歷史',
      prePayFee: '預付收款',
      billingRules: '費用規則',
      setFee: '設置費用',
      ownerShops: '業主商鋪',
      owner: '業主信息',
      receiptReprint: '補打收據',
      batchCreate: '批量創建',
      customImport: '自定義匯入',
      shopNumPlaceholder: '請輸入商鋪編號',
      selectLocationFirst: '請先選擇位置',
      query: '查詢',
      reset: '重置',
      loadLocationError: '載入位置失敗',
      loadShopError: '載入商鋪失敗'
    },
    shopCreatePayFee: {
      title: '商鋪批量創建費用',
      feeType: '費用類型',
      selectFeeType: '請選擇費用類型',
      feeItem: '費用項',
      selectFeeItem: '請選擇費用項',
      startTime: '開始時間',
      selectStartTime: '請選擇開始時間',
      endTime: '結束時間',
      selectEndTime: '請選擇結束時間',
      amount: '金額',
      inputAmount: '請輸入金額',
      rateCycle: '計費週期',
      inputRateCycle: '請輸入計費週期',
      rate: '費率',
      inputRate: '請輸入費率',
      rateStartTime: '費率開始時間',
      selectRateStartTime: '請選擇費率開始時間',
      location: '位置',
      selectLocation: '請選擇位置',
      shop: '商鋪',
      selectAll: '全選',
      noShop: '暫無可選商鋪',
      validateError: '請完善必填資訊',
      noShopSelected: '請至少選擇一個商鋪'
    },
    simplifyShopFee: {
      selectFeeType: '選擇費用類型',
      selectFeeItem: '選擇費用項',
      selectStatus: '選擇狀態',
      valid: '有效',
      feeEnd: '已終止',
      batchPayment: '批量繳費',
      prePayFee: '預付收款',
      feeItem: '費用項',
      feeFlag: '費用標識',
      feeType: '費用類型',
      receivableAmount: '應收金額',
      chargeYearMonth: '計費年月',
      receivablePeriod: '應收期間',
      description: '描述',
      remark: '備註',
      status: '狀態',
      operation: '操作',
      moreOperations: '更多',
      cancelFee: '取消費用',
      feeChange: '費用變更',
      splitFee: '費用拆分',
      details: '詳情',
      payment: '繳費',
      paymentHistory: '歷史',
      note1: '注意：應收結束時間為"-"表示未開始收取或已停止收費',
      note2: '應收金額為-1一般表示費用項公式設置有誤',
      arrearsSubtotal: '欠費小計：'
    },
    simplifyShopPrePayFee: {
      addPrePay: '新增預付',
      feeName: '費用項',
      payerObjName: '繳費對象',
      cycles: '週期(月)',
      receivableReceivedAmount: '應收/實收',
      remainAmount: '剩餘金額',
      paymentMethod: '支付方式',
      prePayPeriod: '預付期間',
      status: '狀態',
      createTime: '創建時間',
      amount: '金額',
      amountRequired: '金額不能為空',
      remark: '備註',
      remarkPlaceholder: '請輸入備註'
    },
    simplifyShopOwner: {
      ownerFace: '照片',
      name: '姓名',
      gender: '性別',
      male: '男',
      female: '女',
      idCard: '身份證號',
      address: '地址',
      roomCount: '房屋數',
      memberCount: '成員數',
      oweFee: '欠費',
      actions: '操作',
      detail: '詳情'
    },
    simplifyShopOwnerShops: {
      batchPay: '批量繳費',
      shopCode: '商鋪編號',
      location: '位置',
      area: '面積',
      validity: '有效期',
      shopStatus: '狀態',
      shopOweFee: '欠費',
      actions: '操作',
      choose: '選擇',
      currentShop: '當前商鋪',
      subtotalOweFee: '欠費合計'
    },
    shopCreateFeeAdd: {
      createFee: '創建費用',
      shop: '商鋪',
      feeType: '費用類型',
      selectFeeType: '請選擇費用類型',
      feeItem: '費用項',
      selectFeeItem: '請選擇費用項',
      billingStartTime: '計費開始時間',
      enterBillingStartTime: '請選擇計費開始時間',
      billingEndTime: '計費結束時間',
      enterBillingEndTime: '請選擇計費結束時間',
      feeAmount: '費用金額',
      enterFeeAmount: '請輸入費用金額',
      feeTypeRequired: '費用類型不能為空',
      feeItemRequired: '費用項不能為空',
      billingStartTimeRequired: '計費開始時間不能為空',
      billingEndTimeRequired: '計費結束時間不能為空',
      amountRequired: '金額不能為空',
      amountFormatError: '請輸入有效的金額',
      endTimeAfterStart: '結束時間必須晚於開始時間',
      createSuccess: '費用創建成功',
      createFailed: '創建費用失敗'
    },
    feeDetailShopFeeRule: {
      createFee: '創建費用',
      tempFee: '臨時費用',
      ruleId: '規則ID',
      feeItem: '費用項',
      feeFlag: '費用類型',
      createTime: '創建時間',
      validity: '有效期',
      formula: '公式',
      unitPrice: '單價',
      additionalFee: '附加費',
      status: '狀態',
      valid: '有效',
      invalid: '無效',
      billDate: '帳單日',
      billCycle: '帳單週期',
      monthly: '按月',
      operation: '操作',
      change: '編輯',
      manualFinish: '手動終止',
      cancel: '取消'
    },
    doImportShopCreateFee: {
      title: '匯入商鋪創建費用',
      template: '範本',
      downloadTemplate: '下載範本',
      selectFile: '選擇檔案',
      clickUpload: '點擊上傳',
      fileTip: '只能上傳xls/xlsx檔案，且不超過2MB',
      validate: {
        invalidFileType: '檔案格式不正確，僅支援xls/xlsx',
        fileTooLarge: '檔案大小不能超過2MB'
      }
    }
  }
}